import { useRef } from 'react'

export interface SingleFlight {
  tryAcquire: () => boolean
  release: () => void
  isHeld: () => boolean
}

export function createSingleFlight(): SingleFlight {
  let held = false
  return {
    tryAcquire: () => {
      if (held)
        return false
      held = true
      return true
    },
    release: () => {
      held = false
    },
    isHeld: () => held,
  }
}

export function useSingleFlight(): SingleFlight {
  const ref = useRef<SingleFlight>()
  ref.current ??= createSingleFlight()
  return ref.current
}

export async function runSingleFlight(
  latch: SingleFlight,
  operation: () => Promise<void> | void,
): Promise<boolean> {
  if (!latch.tryAcquire())
    return false
  try {
    await operation()
    return true
  }
  finally {
    latch.release()
  }
}
